<template>
    <div class="animated fadeIn">
        <ComponentHeader
            title="Business Plan Details"
            :hasSearch="false"
            :hasCreate="false"
            :hasReload="false"
            :hasback="true"
            backButtonText="Back"
            @back-press="backButton"
        >
            <template #heading-before-search>
                <div class="bp-header-actions">
                    <b-button
                        variant="primary"
                        class="profile-btn"
                        @click="
                            $router.push({
                                name: 'Edit Business Plan',
                                params: {
                                    id: planDetails._id,
                                },
                            })
                        "
                    >
                        Edit Business Plan
                    </b-button>
                    <b-button
                        variant="danger"
                        class="delete-btn"
                        @click="deleteBusinessPlan"
                    >
                        Delete
                    </b-button>
                </div>
            </template>
        </ComponentHeader>
        <b-card>
            <b-row class="mx-1">
                <b-col cols="12" sm="12" md="2">
                    <b-col>
                        <v-avatar size="75">
                            <img :src="planDetails.image" alt />
                        </v-avatar>
                    </b-col>
                    <b-col
                        class="price"
                        v-if="
                            planDetails &&
                            planDetails.subscriptions &&
                            planDetails.subscriptions[
                                planDetails.subscriptions.length - 1
                            ].pricing
                        "
                    >
                        <span class="amount">Price ₹ {{ totalPrice }}</span>
                    </b-col>
                </b-col>

                <b-col cols="12" sm="12" md="8">
                    <div>
                        <h5 class="mt-1 font1">
                            Plan Name:
                            <span class="mt-1 font2"
                                >{{
                                    planDetails.plan_name ||
                                    planDetails.planName ||
                                    ""
                                }}
                            </span>
                        </h5>
                    </div>
                    <div class="mt-4">
                        <h5 class="mt-1 font1">
                            Description:
                            <span class="mt-1 mb-4 font2"
                                >{{ planDetails.description }}
                            </span>
                        </h5>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-row
            ><b-col cols="12" sm="12" md="7">
                <h3 class="ml-2">Added Subscription</h3>
            </b-col>
        </b-row>
        <b-table
            :hover="true"
            :items="features1"
            :striped="striped"
            :fields="Column1"
            :dark="false"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            id="subscription-table"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="header"
            class="mt-3"
            show-empty
            :no-border-collapse="true"
            @filtered="onFilter"
        ></b-table>

        <b-row
            ><b-col cols="12" sm="12" md="7">
                <h3 class="ml-2">Add Feature</h3>
            </b-col>
        </b-row>
        <b-table
            :hover="true"
            :items="displayFeatures"
            :striped="striped"
            :fields="Column"
            :dark="false"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            id="feature-table"
            :current-page="featureCurrentPage"
            :per-page="featurePerPage"
            thead-class="header"
            class="mt-3"
            show-empty
            :no-border-collapse="true"
            @filtered="onFeatureFiltered"
        ></b-table>
        <div class="pagination-wrapper">
            <b-pagination
                v-if="displayFeatures.length > 0 && featureTotalRows > featurePerPage"
                v-model="featureCurrentPage"
                :total-rows="featureTotalRows"
                :per-page="featurePerPage"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
            />
        </div>
    </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select.vue";
import { mapGetters, mapActions } from "vuex";
export default {
    components: {
        ComponentHeader,
        ebSelect,
    },
    data() {
        return {
            text: "",
            Column1: [
                { label: "PlanName", key: "planName" },
                { label: "Description", key: "planDescription" },
                { label: "Plan Price", key: "pricing" ,class: "text-center"},
            ],
            Column: [
                { label: "Feature Name", key: "name" },
                {
                    label: "Description",
                    key: "description",
                    class: "textAlignment",
                },
                {
                    label: "Permission Added",
                    key: "_permissionCount",
                    class: "text-center ",
                },
            ],
            features: [],
            features1: [],
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            currentPage: 1,
            perPage: 9,
            filterCount: 0,
            featureCurrentPage: 1,
            featurePerPage: 10,
            planDetails: "",
        };
    },
    computed: {
        ...mapGetters({
            getFeatureList: "businessPlan/GetfeatureList",
            businessPlanList: "businessPlan/GetBusinessPlanList",
            getFeatureDetails: "businessPlan/GetfeatureDetails",
            featureStoreList: "feature/GetFeatureList",
        }),
        displayFeatures() {
            const fromDetails = this.getFeatureDetails;
            const fromPlan = this.features;
            const gl = this.getFeatureList;
            const fl = this.featureStoreList;
            let fullFeatureList = Array.isArray(gl)
                ? gl
                : (gl &&
                    (gl.permissions ||
                        gl.data ||
                        gl.features ||
                        gl.response)) ||
                  [];
            if (fullFeatureList.length === 0 && fl) {
                fullFeatureList = Array.isArray(fl)
                    ? fl
                    : (fl && (fl.permissions || fl.data || fl.response)) || [];
            }
            const detailsList = Array.isArray(fromDetails)
                ? fromDetails
                : (fromDetails && fromDetails.features) || [];
            const rawList =
                detailsList.length > 0
                    ? detailsList
                    : Array.isArray(fromPlan) && fromPlan.length > 0
                    ? fromPlan
                    : [];
            return rawList.map((item) => {
                let perm =
                    item.permission ||
                    item.permissions ||
                    item.permissionIds ||
                    item.addedPermissions ||
                    [];
                if (!Array.isArray(perm) && perm && typeof perm === "object") {
                    perm = perm.ids || perm.items || perm.data || [];
                }
                let count = Array.isArray(perm) ? perm.length : 0;
                if (count === 0 && fullFeatureList.length > 0) {
                    const fullFeature =
                        fullFeatureList.find(
                            (f) =>
                                (f._id && f._id === item._id) ||
                                (f.name && f.name === item.name),
                        ) || {};
                    const fullPerm =
                        fullFeature.permission ||
                        fullFeature.permissions ||
                        [];
                    count = Array.isArray(fullPerm) ? fullPerm.length : 0;
                }
                return { ...item, _permissionCount: count };
            });
        },
        featureTotalRows() {
            return this.displayFeatures.length;
        },
        getSubscription() {
            const data = this.getSubscriptionList;
            let newList = [];
            data.map((each) => {
                let arrayObj = {
                    id: each._id,
                    planName: each.planName,
                    planDescription: each.planDescription,
                    pricing: each.pricing.price,
                };
                newList.push(arrayObj);
            });
            return newList;
        },
        totalPrice() {
            let total = 0;
            total = this.features1.reduce((acc, a) => {
                return acc + a.pricing;
            }, 0);
            return total || 0;
        },
    },
    methods: {
        ...mapActions({
            fetchFeatureList: "businessPlan/featureList",
            fetchBusinessPlanList: "businessPlan/businessPlanList",
            deletePlan: "businessPlan/deleteBusinessPlan",
            fetchFeatureStoreList: "feature/fetchFeatureList",
        }),
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        onFeatureFiltered() {
            this.featureCurrentPage = 1;
        },
        backButton() {
            this.$router.push({ path: "/businessPlan" });
        },
        async deleteBusinessPlan() {
            await this.$swal({
                title: "Are you sure?",
                text: "You can't revert this action!!",
                type: "warning",
                showCancelButton: true,
                 cancelButtonText: "Cancel",
                confirmButtonText: "Delete",
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                reverseButtons: true,  
                
            }).then((result) => {
                if (result.value) {
                    const payload = { id: this.$route.params.id };
                    this.deletePlan(payload).then((result) => {
                        this.$toasted.success(
                            "Business Plan Deleted Successfully",
                        );
                        this.fetchBusinessPlanList().catch((error) => {
                            this.$toasted.error(error.message);
                        });
                    });
                    this.$router.push("/businessPlan");
                }
            });
        },

        async fetchBusinessPlanDetails() {
            const data = await this.$store.dispatch(
                "businessPlan/businessPlanDetails",
                {
                    id: this.$route.params.id,
                },
            );
            this.planDetails = data?.data?.response;
            this.features = data?.data?.response.features || [];
            this.features1 = data?.data?.response.subscriptions || [];
            this.featureCurrentPage = 1;
            return this.planDetails;
        },
        async fetchFeatureDetails() {
            await this.$store.dispatch("businessPlan/featureListDetail", {
                id: this.$route.params.id,
            });
        },
    },
    watch: {
        displayFeatures: {
            handler() {
                const maxPage = Math.max(
                    1,
                    Math.ceil(this.displayFeatures.length / this.featurePerPage),
                );
                if (this.featureCurrentPage > maxPage) {
                    this.featureCurrentPage = maxPage;
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.fetchBusinessPlanDetails();
        this.fetchFeatureDetails();
        this.fetchFeatureList();
        this.fetchFeatureStoreList();
    },
};
</script>
<style>
.bp-header-actions {
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.bp-header-actions .profile-btn,
.bp-header-actions .delete-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    height: 34px;
    padding: 0 14px;
}

.refresh-button {
    position: absolute;
    top: 12px;
    font-size: large;
    z-index: 1;
    right: 15px;
    width: 42px;
    height: 35px;
    padding: 0px;
}

.amount {
    font-weight: 600;
}
.price {
    font-size: 14px;
    color: black;
    font-weight: 600px;
    margin-top: 10px;
}
.profile-btn {
    background-color: var(--primary);
    height: 38px;
}
.delete-btn {
    height: 38px;
}
.delete-btn:hover {
    background-color: #ff3a3a;
}
.feature-select {
    margin-left: 50px;
}
.font1 {
    font-size: 15px;
}
.font2 {
    font-weight: lighter;
    font-size: 14px;
    line-height: 1.5rem;
}
td.textAlignment {
    text-align: justify !important;
    white-space: pre-wrap;
}

.pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
}
</style>
